__turbopack_context__.v({
  "description": "Projects-module-scss-module__ftb2bW__description",
});
